import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, inject, Output, signal } from '@angular/core';
import { Icon } from '../../../shared/components/icon';
import { Divider } from '../../../shared/components/divider';
import { Router } from '@angular/router';
import { selectUser } from '../../../state/auth/auth.selectors';
import { User } from '../../../features/login/models/user';
import { Store } from '@ngrx/store';
import { AuthActions } from '../../../state/auth/auth.actions';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.html',
  styleUrls: ['./header-mobile.scss'],
  imports: [CommonModule, Icon, Divider],
})
export class HeaderMobile {
  isOpenSidebar = signal<boolean>(false);
  isMenuOpen = signal<boolean>(false);
  //  isOpen = signal<boolean>(false);
  @Output() isSidebarOpen = new EventEmitter<boolean>();
  private router = inject(Router);
  private store = inject(Store);
  user = this.store.selectSignal<User | null>(selectUser);

  userLogged = computed(() => {
    const initial = `${this.user()?.nome.charAt(0).toUpperCase()}${this.user()?.cognome.charAt(0).toUpperCase()}`;
    const fullName = `${this.user()?.nome} ${this.user()?.cognome}`;
    return {
      initial: initial,
      fullName: fullName,
    };
  });

  openSidebar() {
    this.isOpenSidebar.set(!this.isOpenSidebar());
    this.isSidebarOpen.emit(this.isOpenSidebar());
  }

  openMenu() {
    this.isMenuOpen.set(!this.isMenuOpen());
  }
  goToLogin() {
    this.router.navigate(['/login']);
    this.isOpenSidebar.set(false);
    this.isSidebarOpen.emit(this.isOpenSidebar());
  }

  logout() {
    this.isMenuOpen.set(false);
    this.store.dispatch(AuthActions.logout({ spid: true }));
  }
}
